import React from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {
    marginTop: 24,
    marginBottom: 40,
    paddingBottom: 20,
    width: "100%",
    display: "block",
  },
  label: {
    color: "#6F9CEB",
    fontWeight: 500,
    fontSize: 13,
    textAlign: "center",
    marginTop: 10,
    maxWidth: 150,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.2,
  },
  step: {
    background: "#6F9CEB",
    borderRadius: "50%",
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#fff",
    fontWeight: 700,
    fontSize: 10,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    marginBottom: 0,
  },
  bar: {
    width: "100%",
    maxWidth: "100%",
    margin: 0,
    padding: 0,
    position: "relative",
  },
  stepType: {
    color: "#6F9CEB",
    fontWeight: 700,
    fontSize: 11,
    marginTop: 6,
    marginBottom: 0,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  tooltip: {
    backgroundColor: `#6F9CEB !important`,
    color: `#fff !important`,
    fontWeight: 500,
    fontSize: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    border: "1px solid #6F9CEB",
  },
  arrow: {
    color: "#6F9CEB",
  },
  stepWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: 90,
    marginBottom: 0,
    position: "relative",
    height: 56,
  },
  belowLine: {
    marginTop: 28,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});

const getStepTypeLabel = (type, customerStopsLabel) => {
  switch (type) {
    case "start":
      return "Start";
    case "customer":
      return customerStopsLabel || "Customer Stops";
    case "end":
      return "End";
    case "after_end":
      return "After End";
    case "before_end":
      return "Before End";
    default:
      return "";
  }
};

const TourRouteVisualization = ({
  start,
  customerStops,
  end,
  stopsBeforeEnd,
  stopsAfterEnd,
  customerStopsLabel,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const steps = [
    { label: start, type: "start" },
    ...customerStops.map((stop, i) => ({ label: stop, type: "customer", idx: i })),
    ...stopsBeforeEnd.map((stop, i) => ({ label: stop, type: "before_end", idx: i })),
    { label: end, type: "end" },
    ...stopsAfterEnd.map((stop, i) => ({ label: stop, type: "after_end", idx: i })),
  ].filter((s) => s.label);

  return (
    <div className={classes.container}>
      <div className={classes.bar}>
        <ProgressBar percent={100} filledBackground="#6F9CEB" unfilledBackground="#555" height={3}>
          {steps.map((step, idx) => (
            <Step key={idx} transition="scale">
              {() => (
                <div className={classes.stepWrapper}>
                  <div className={classes.step}>{idx + 1}</div>
                  <div className={classes.belowLine}>
                    <Tooltip
                      title={step.label}
                      placement="bottom"
                      arrow
                      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                    >
                      <div className={classes.label}>{step.label}</div>
                    </Tooltip>
                    <div className={classes.stepType}>{t(getStepTypeLabel(step.type, customerStopsLabel))}</div>
                  </div>
                </div>
              )}
            </Step>
          ))}
        </ProgressBar>
      </div>
    </div>
  );
};

export default TourRouteVisualization;
